import { IPerson } from "./person.model";
import { IContactInformation } from "./contact-information.model";
import { ITechResource } from "./tech-resource.model";
import { IJobExperience } from "./job-experience.model";
import { IAcademicEducation } from "./academic-education.model";
import { ICandidateLanguage } from "./candidate-language.model";
import { ICandidateToApplication } from "./candidate-to-application.model";
import { ICandidateQuestionResponse } from "./candidate-question-response.model";
import { IDocument } from "./document.model";
import { IReferred } from "./referred.model";
import { IAddress } from "./address.model";
import { ICandidateMedicalInformation } from "./candidate-medical-information.model";
import { ICandidateDiverseVulnerableGroup } from "./diverse-vulnerable-group";
import { ICode } from "./code.model";

export interface ICandidate {
  id?: number;
  person?: IPerson | null;
  contactInformation?: IContactInformation | null;
  techResource?: ITechResource | null;
  candidateMedicalInformation?: ICandidateMedicalInformation | null;
  candidateDiverseVulnerableGroup?: ICandidateDiverseVulnerableGroup | null;
  jobExperiences?: IJobExperience[] | null;
  academicEducations?: IAcademicEducation[] | null;
  languages?: ICandidateLanguage[] | null;
  candidateToApplications?: ICandidateToApplication[] | null;
  candidateQuestionResponses?: ICandidateQuestionResponse[] | null;
  documents?: IDocument[] | null;
  referreds?: IReferred[] | null;
  address?: IAddress | null;
  attachedFile?: any;
  errorSaved?: boolean;
  code?: ICode;
}

export const defaultValue: Readonly<ICandidate> = {};
